import { render } from "./TranslationEditor.vue?vue&type=template&id=4520f066"
import script from "./TranslationEditor.vue?vue&type=script&lang=js"
export * from "./TranslationEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__